import React, { useContext, useEffect, useState } from 'react';
import { View, Text, Pressable } from 'react-native';
import { useLazyQuery } from '@apollo/client';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments } from '@fortawesome/free-regular-svg-icons';
import {
  faComments as faCommentsSolid
} from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

import AuthContext from 'app/src/contexts/AuthContext';
import Modal from 'app/src/elements/Modal';

import { RESOURCE_NOTIFICATIONS } from './queries';
import { CreatedTime } from './show';
import NewNotification from './new';
import Body from './Body';

const Notification = styled(View)`
  flex-direction: column;
  margin-bottom: 10px;
`;

const ResourceNotifications = ({ resource, field, labeled }) => {
  const [showModal, setShowModal] = useState(false);

  const { user } = useContext(AuthContext);

  const [getNotifications, { data, refetch }] = useLazyQuery(
    RESOURCE_NOTIFICATIONS,
    {
      variables: {
        resourceType: resource.__typename,
        resourceId: resource.id,
        field,
        sellerId: user?.seller.id,
      }
    }
  );

  useEffect(() => {
    if ('undefined' === typeof resource.customNotificationsCount) {
      getNotifications();
    }
  }, []);

  const getOrRefetch = () => {
    if (data) {
      refetch();
    } else {
      getNotifications();
    }
  }

  let notifications = [];
  let icon = faComments;
  if (data) {
    const fieldNotifications = data.fieldDeltas.map(fieldDelta => {
      const fieldValues = fieldDelta.fields
        .find(fieldDetail => fieldDetail.name === field);

      return {
        ...fieldDelta,
        createdByName: fieldDelta.userDescription,
        body: `Updated Value to: ${fieldValues.newValue}`,
        oldValue: fieldValues.oldValue,
        newValue: fieldValues.newValue,
      };
    }).filter(fieldDelta => {
      if (fieldDelta.action === 'create') {
        if (!fieldDelta.newValue) { return false; }
      }

      if (!fieldDelta.oldValue) {
        if (!fieldDelta.newValue) { return false; }
        if ('0.0' == fieldDelta.newValue) { return false; }
      }

      return true;
    });

    notifications = data.resourceNotifications.concat(fieldNotifications)
      .sort((a, b) => moment(a.createdAt) - moment(b.createdAt));

    const customNotifications = data.resourceNotifications
      .filter(notification => notification.custom);

    if (customNotifications.length > 0) {
      icon = faCommentsSolid;
    }
  } else if (resource?.customNotificationsCount) {
    icon = faCommentsSolid;
  }

  return (
    <>
      <Pressable
        onPress={() => { getOrRefetch(); setShowModal(!showModal); }}
      >
        <View style={{flexDirection: 'row', gap: 4}}>
          {labeled && <Text>Comments</Text>}
          <FontAwesomeIcon icon={icon} color={labeled ? 'black' : 'green'} />
        </View>
      </Pressable>
      {showModal && (
        <Modal
          showModal={showModal}
          setShowModal={setShowModal}
          modalType="Comments"
          objectName={resource.name}
        >
          {notifications.map(notification => (
            <Notification key={`${notification.__typename}-${notification.id}`}>
              <Body content={notification.body} />
              <CreatedTime>
                {moment(notification.createdAt).format('MM-DD-YY \@ hh:mmA')}
                {' - '}
                {notification.createdByName}
              </CreatedTime>
            </Notification>
          ))}
          <NewNotification
            resource={resource}
            field={field}
            refetch={refetch}
            users={data?.mentionUsers || []}
          />
        </Modal>
      )}
    </>
  );
};

export default ResourceNotifications;
